import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';

import { AppComponent } from './app.component';

/* Core Module */
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';

import { AppRoutingModule } from './app-routing/app-routing.module';

import { LoginModule } from './login/login.module';

import { MembershipModule } from './membership/membership.module';

/* Unattached Components */
import { LandingComponent } from './unattached/landing/landing.component';
import { ReceiptComponent } from './unattached/receipt/receipt.component';
import { OrderReceiptComponent } from './unattached/order-receipt/order-receipt.component';
import { SupportComponent } from './unattached/support/support.component';
import { TermsComponent } from './unattached/terms/terms.component';
import { ToastComponent } from './shared/toast/toast.component';
import { providePostHogErrorHandler } from './posthog-error-handler';

@NgModule({
	declarations: [
		AppComponent,
		LandingComponent,
		ReceiptComponent,
		OrderReceiptComponent,
		SupportComponent,
		TermsComponent,
		ToastComponent,
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		CoreModule,
		SharedModule,
		LoginModule,
		MembershipModule,
		NgSelectModule,
	],
	providers: [
		providePostHogErrorHandler(),
	],
	bootstrap: [AppComponent],
})
export class AppModule {
}
